module.exports = __webpack_public_path__ + "static/media/referrals_dollar.386117ee.svg";